import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Diamond } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data } });
      } catch (e) {
        const detail = e?.response?.data?.detail;
        if (detail && typeof detail === "object" && detail.code === "INVITE_REQUIRED") {
          navigate("/login?reason=invite_required", { replace: true });
        } else {
          navigate("/login?reason=session_failed", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0D14]">
      <div className="flex flex-col items-center gap-4 animate-pulse">
        <Diamond className="w-12 h-12 text-[#7DD3FC]" />
        <p className="font-overline text-slate-500">Establishing secure session…</p>
      </div>
    </div>
  );
}
